import {
    FETCH_IAT_TASK_SUCCESS,
    FETCH_IAT_TASK_FAILURE,
    ANSWER_IAT_TASK_SUCCESS,
    ANSWER_IAT_TASK_FAILURE
} from './constants';

import * as IATService from '@/services/iat'

const actions = {
    async fetchIATTask({ commit }, payload) {
        const { taskName } = payload
        try {
            const iatTask = await IATService.fetchIATTask(taskName)
            commit(FETCH_IAT_TASK_SUCCESS, iatTask.iatTask)
        } catch(e) {
            commit(FETCH_IAT_TASK_FAILURE)
        }
    },

    async answerIATTask({ commit }, payload) {
        const { interactionInstanceId, itemId, result } = payload
        try {
            await IATService.answerIATTask(interactionInstanceId, itemId, result)
            commit(ANSWER_IAT_TASK_SUCCESS)

        } catch(e) {
            commit(ANSWER_IAT_TASK_FAILURE)
        }
    }
}

export default actions
